import { RedoOutlined } from "@ant-design/icons";
import { Button, Card, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { MessagesService } from "services/Messages";
import dayjs from "dayjs";
import Loading from "components/shared-components/Loading";
import { UserApi } from "api/UserApi";
import Search from "antd/lib/input/Search";
import { formatCurrency } from "utils/formatCurrency";

const initial_filter = {
  keyword: null,
  page: 1,
  limit: 10,
};

export default function Customers() {
  const columns = [
    {
      title: "Имя",
      width: 150,
      dataIndex: "chat_id",
      key: "chat_id",
      render: (_, user) => `${user.first_name ?? ""} ${user.last_name ?? ""}`,
    },
    {
      title: "Итого",
      width: 100,
      dataIndex: "total",
      key: "total",
      render: (total) => formatCurrency(total),
    },
    {
      title: "Телеграм",
      width: 100,
      dataIndex: "username",
      key: "username",
      render: (username) => {
        return (
          <a href={`https://t.me/${username}`} target="_blank">
            Telegram
          </a>
        );
      },
    },
    {
      title: "Номер телефона",
      dataIndex: "phone_number",
      key: "phone_number",
      width: 100,
    },
    {
      title: "Дата создания",
      width: 100,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (record) => {
        return dayjs(record).format("DD.MM.YYYY, HH:MM");
      },
    },
  ];
  // States
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(initial_filter);

  // Get application types
  useEffect(() => {
    fetch(filter);
  }, []);

  function fetch(filter) {
    setLoading(true);
    UserApi.get(filter)
      .then((res) => {
        setData(res);
        setFilter({
          ...filter,
          total: res.total,
          page: res.page,
        });
        setLoading(false);
      })
      .catch((err) => {
        MessagesService.error(err.message);
        setLoading(false);
      });
  }
  // Render
  return loading ? (
    <Loading />
  ) : (
    <>
      <Card>
        <h4 className="font-semibold text-base mb-3">Покупатели</h4>
        <Row className="justify-between items-center">
          <Search
            placeholder="Поиск по имени пользователя..."
            type="text"
            className="w-3/5"
            size="large"
            enterButton="Поиск"
            defaultValue={filter.keyword}
            onSearch={(value) => {
              setFilter({ ...filter, keyword: value });
              fetch({ ...filter, keyword: value });
            }}
          />
          <Button
            icon={<RedoOutlined />}
            size="large"
            onClick={() => fetch(filter)}
          >
            Обновить
          </Button>
        </Row>
      </Card>
      <Card>
        <Table
          columns={columns}
          loading={loading}
          onChange={(p, _, sort) => {
            const f = {
              ...filter,
              page: p.current,
              limit: p.pageSize,
            };
            setFilter(f);
            fetch(f);
          }}
          pagination={{
            current: filter?.page,
            total: data?.total,
            pageSize: filter?.limit,
          }}
          dataSource={data?.items}
        />
      </Card>
    </>
  );
}
